import React from 'react';
import Checklist from '../../containers/Checklists/Checklist';
import { Layout } from '../../components/Layout/Layout';
import { useLocation } from 'react-router-dom';
import type { NavigatedPageState } from '../chat/ReadReceipts';

function ChecklistPage() {
  const location = useLocation();
  const locationState = location.state as NavigatedPageState;

  return (
    <Layout
      isMessageLayout
      message="checkListInfo_title"
      to={locationState?.prevPath || '/checklists'}
      showBottomTabs
      showDots
    >
      <Checklist />
    </Layout>
  );
}

export default ChecklistPage;
